// extracted by mini-css-extract-plugin
export default {"mainView":"Inicio_mainView__C6JCz","outletContainer":"Inicio_outletContainer__i4KbT","mainContainer":"Inicio_mainContainer__FE+4C"};